<div class="createClaimsContainer">
  <div class="innerContainer">
    <div>
      <h1 *ngIf="isStandard" class="title">{{ standardTitle }}</h1>
      <h1 *ngIf="isIllness" class="title">{{ illnessTitle }}</h1>
      <h1 *ngIf="isPersonalized" class="title">{{ personalizedTitle }}</h1>
    </div>

    <div class="progressContainer" *ngIf="activeStepIndex > 1">
      <dxo-progress-bar [progress]="progressPercentage" [showPercentText]="true"> </dxo-progress-bar>
    </div>

    <form [formGroup]="createClaimForm">
      <div class="claim-type-card" *ngIf="activeStepIndex === 1">
        <dxo-card [bodyHeader]="claimTypeCardHeader">
          <div class="card-div">
            <card-body>
              <dxo-radio-select
                formControlName="claimType"
                [data]="claimTypeRadioData"
                (valueChange)="claimType$.next($event)"
              >
              </dxo-radio-select>
            </card-body>
          </div>
        </dxo-card>
      </div>

      <div class="time-away" *ngIf="activeStepIndex === 2">
        <dxo-card [bodyHeader]="timeAwayCardHeader">
          <div class="card-div">
            <card-body>
              <dxo-radio-select
                formControlName="timeAwayReason"
                [data]="timeAwayRadioData"
                (valueChange)="timeAwayReason$.next($event)"
              >
              </dxo-radio-select>
              <div class="back-button">
                <dxo-button icon="chevron_left" text="Back" (handleClick)="goBackStep(2)"> </dxo-button>
              </div>
            </card-body>
          </div>
        </dxo-card>
      </div>

      <div *ngIf="activeStepIndex === 3">
        <dxo-card [bodyHeader]="nameCardHeader">
          <div class="card-div">
            <card-body>
              <div class="first-name">
                <dxo-text-input
                  [label]="firstName"
                  formControlName="firstName"
                  [errorControl]="formErrors.firstName"
                  (valueChange)="firstName$.next($event)"
                >
                </dxo-text-input>
              </div>
              <dxo-text-input
                [label]="lastName"
                formControlName="lastName"
                [errorControl]="formErrors.lastName"
                (valueChange)="lastName$.next($event)"
              >
              </dxo-text-input>
              <div class="button-container">
                <div class="back-button">
                  <dxo-button icon="chevron_left" text="Back" (handleClick)="goBackStep(3)"> </dxo-button>
                </div>
                <dxo-button
                  icon="chevron_right"
                  iconColor="white"
                  [primary]="true"
                  text="Next"
                  (handleClick)="goToStep('next')"
                  [disabled]="isDisabledStep3"
                >
                </dxo-button>
              </div>
            </card-body>
          </div>
        </dxo-card>
      </div>

      <div *ngIf="activeStepIndex === 4" class="location-card">
        <dxo-card [bodyHeader]="locationCardHeader">
          <div class="card-div">
            <card-body>
              <div class="street-address">
                <dxo-text-input
                  [label]="streetAddress"
                  formControlName="streetAddress"
                  [errorControl]="formErrors.streetAddress"
                  (valueChange)="streetAddress$.next($event)"
                >
                </dxo-text-input>
              </div>
              <div class="city">
                <dxo-text-input [label]="city" formControlName="city" [errorControl]="formErrors.city">
                </dxo-text-input>
              </div>
              <div class="state-zip">
                <div class="state">
                  <dxo-dropdown
                    [optionsObjects]="statesDropdown"
                    [label]="state"
                    formControlName="state"
                    [errorControl]="formErrors.state"
                    type="number"
                  >
                  </dxo-dropdown>
                </div>
                <div class="zip">
                  <dxo-text-input
                    [maxlength]="5"
                    [characterSet]="numericCharSet"
                    [label]="zipcode"
                    formControlName="zipCode"
                    [errorControl]="formErrors.zipCode"
                    (valueChange)="zipCode$.next($event)"
                  >
                  </dxo-text-input>
                </div>
              </div>
              <div class="button-container">
                <div class="back-button">
                  <dxo-button icon="chevron_left" text="Back" (handleClick)="goBackStep(4)"> </dxo-button>
                </div>
                <dxo-button
                  icon="chevron_right"
                  iconColor="white"
                  text="Next"
                  [primary]="true"
                  (handleClick)="goToStep('next')"
                  [disabled]="isDisabledStep4"
                >
                </dxo-button>
              </div>
            </card-body>
          </div>
        </dxo-card>
      </div>

      <div *ngIf="activeStepIndex === 5">
        <dxo-card [bodyHeader]="personalInfoCardHeader">
          <div class="card-div">
            <card-body>
              <div class="birth-social">
                <div class="birth">
                  <dxo-text-input
                    type="date"
                    [characterSet]="dateCharRegex"
                    label="Date of birth (DD/MM/YYYY)"
                    formControlName="birthdate"
                    [errorControl]="formErrors.birthdate"
                    (valueChange)="birthdate$.next($event)"
                    type="date"
                    input-id="birthdate"
                    [maxlength]="10"
                  >
                  </dxo-text-input>
                </div>
                <div class="social">
                  <dxo-text-input
                    [label]="ssn"
                    formControlName="ssn"
                    (input)="onSSNInputChange($event)"
                    [maxlength]="11"
                    [errorControl]="formErrors.ssn"
                    (valueChange)="ssn$.next($event)"
                  >
                  </dxo-text-input>
                </div>
              </div>
              <div class="phone-ext">
                <div class="phone">
                  <dxo-text-input
                    type="tel"
                    [label]="phoneNumber"
                    formControlName="phoneNumber"
                    (input)="onPhoneNumberInputChange($event)"
                    [errorControl]="formErrors.phoneNumber"
                    (valueChange)="phoneNumber$.next($event)"
                  >
                  </dxo-text-input>
                </div>
                <div class="extension">
                  <dxo-text-input label="Extension (optional)" formControlName="extension" [maxlength]="5">
                  </dxo-text-input>
                </div>
              </div>
              <div class="button-container">
                <div class="back-button">
                  <dxo-button icon="chevron_left" text="Back" (handleClick)="goToStep('prev')"> </dxo-button>
                </div>
                <dxo-button
                  icon="chevron_right"
                  iconColor="white"
                  text="Next"
                  [primary]="true"
                  [disabled]="isDisabledStep5"
                >
                </dxo-button>
              </div>
            </card-body>
          </div>
        </dxo-card>
      </div>
    </form>
  </div>
</div>
